module.exports = __webpack_public_path__ + "static/media/logo.ce1209c2.png";